// import React from "react";

// const VisionMissionnew = () => {
//   return (
//     <section className="vision-mission">
//       <div className="container">
//         {/* Section Header */}
//         <div className="row section-row">
//           <div className="col-lg-12">
//             <div className="section-title text-center">
//               <h3 className="wow fadeInUp">Vision • Mission • Commitment</h3>
//               <h2 className="text-anime-style-3" data-cursor="-opaque">
//                 Driving Excellence and Trust in Every Journey
//               </h2>
//             </div>
//           </div>
//         </div>

//         {/* Tabs Navigation */}
//         <div className="row">
//           <div className="col-lg-12">
//             <div
//               className="our-projects-nav wow fadeInUp"
//               data-wow-delay="0.25s"
//             >
//               <ul className="nav nav-tabs" id="myTab" role="tablist">
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link active"
//                     id="vision-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#vision"
//                     type="button"
//                     role="tab"
//                     aria-selected="true"
//                   >
//                     Our Vision
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link"
//                     id="mission-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#mission"
//                     type="button"
//                     role="tab"
//                     aria-selected="false"
//                   >
//                     Our Mission
//                   </button>
//                 </li>
//                 <li className="nav-item" role="presentation">
//                   <button
//                     className="nav-link"
//                     id="commitment-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#commitment"
//                     type="button"
//                     role="tab"
//                     aria-selected="false"
//                   >
//                     Our Commitment
//                   </button>
//                 </li>
//               </ul>
//             </div>

//             {/* Tabs Content */}
//             <div className="vision-mission-box tab-content" id="myTabContent">
//               {/* Vision Tab */}
//               <div
//                 className="tab-pane fade show active"
//                 id="vision"
//                 role="tabpanel"
//               >
//                 <div className="row align-items-center">
//                   <div className="col-lg-6">
//                     <div className="vision-mission-content">
//                       <div className="section-title">
//                         <h3 className="wow fadeInUp">Our Vision</h3>
//                         <h2
//                           className="text-anime-style-3"
//                           data-cursor="-opaque"
//                         >
//                           Becoming India’s Most Trusted Car Rental Brand
//                         </h2>
//                         <p className="wow fadeInUp" data-wow-delay="0.25s">
//                                           Our aspiration is to become the most reliable travel companion, crafting enriching journeys that spark exploration and create cherished memories .
//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-lg-6">
//                     <div className="vision-image">
//                       <figure className="image-anime reveal">
//                         <img
//                           src="images/our-vision-img.jpg"
//                           alt="Our Vision"
//                           className="img-fluid rounded shadow"
//                         />
//                       </figure>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Mission Tab */}
//               <div className="tab-pane fade" id="mission" role="tabpanel">
//                 <div className="row align-items-center">
//                   <div className="col-lg-6">
//                     <div className="vision-mission-content">
//                       <div className="section-title">
//                         <h3>Our Mission</h3>
//                         <h2 data-cursor="-opaque">
//                           Redefining Travel Convenience & Customer Satisfaction
//                         </h2>
//                         <p>
//                           At <strong>Aaryan Travels</strong>, our
//                           mission is To deliver end-to-end travel services with a focus on comfort, convenience, and customer satisfaction, ensuring hassle-free journeys across India and abroad. 

//                         </p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-lg-6">
//                     <div className="vision-image">
//                       <figure className="image-anime reveal">
//                         <img
//                           src="images/our-mission-img.jpg"
//                           alt="Our Mission"
//                           className="img-fluid rounded shadow"
//                         />
//                       </figure>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Commitment Tab */}
//               <div className="tab-pane fade" id="commitment" role="tabpanel">
//                 <div className="row align-items-center">
//                   <div className="col-lg-6">
//                     <div className="vision-mission-content">
//                       <div className="section-title">
//                         <h3>Our Commitment</h3>
//                         <h2 data-cursor="-opaque">
//                           Delivering Comfort, Safety, and Reliability
//                         </h2>
//                         <p>
//                           At <strong>Aaryan Travels</strong>, we are
//                           committed to delivering comfort, safety, and
//                           reliability in every journey. With professionalism and
//                           customer care at the heart of our services, we ensure
//                           every ride reflects our promise of quality and trust.
//                           Here’s what you can always count on with us:
//                         </p>

//                         <div className="vision-mission-list pt-md-3">
//                           <ul>
//                             <li>
//                               <strong>Prompt Response –</strong> We respect your
//                               time. All inquiries are addressed within 20
//                               minutes via email.
//                             </li>
//                             <li>
//                               <strong>Safety First –</strong> Every vehicle is
//                               equipped with GPS tracking and panic buttons to
//                               ensure passenger safety at all times.
//                             </li>
//                             <li>
//                               <strong>Diverse Fleet –</strong> From mid-size
//                               sedans to premium luxury cars, we offer a wide
//                               range of vehicles at competitive prices.
//                             </li>
//                             <li>
//                               <strong>Zero-Refusal Policy –</strong> With our
//                               “never say no” approach, every booking is accepted
//                               and honored with complete dedication.
//                             </li>
//                             <li>
//                               <strong>Backup Assurance –</strong> In the rare
//                               case of a breakdown, a replacement vehicle is
//                               dispatched immediately to avoid delays.
//                             </li>
//                             <li>
//                               <strong>Hygienic Rides –</strong> Every car is
//                               thoroughly cleaned and sanitized before each
//                               journey to ensure comfort and safety.
//                             </li>
//                             <li>
//                               <strong>Professional Chauffeurs –</strong> Our
//                               drivers are well-trained, punctual, courteous, and
//                               committed to delivering an exceptional travel
//                               experience.
//                             </li>
//                             <li>
//                               <strong>Continuous Improvement –</strong> We
//                               actively collect and review customer feedback to
//                               enhance our services continually.
//                             </li>
//                           </ul>
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-lg-6">
//                     <div className="vision-image">
//                       <figure className="image-anime reveal">
//                         <img
//                           src="images/our-approach-img.jpg"
//                           alt="Our Commitment"
//                           className="img-fluid rounded shadow"
//                         />
//                       </figure>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               {/* End Commitment */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default VisionMissionnew;


import React from "react";

const VisionMissionnew = () => {
  return (
    <section className="vision-mission">
      <div className="container">
        {/* Section Header */}
        <div className="row section-row">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <h3 className="wow fadeInUp">Vision • Mission • Commitment</h3>
              <h2 className="text-anime-style-3" data-cursor="-opaque">
                Driving Excellence and Trust in Every Journey
              </h2>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="row">
          <div className="col-lg-12">
            <div
              className="our-projects-nav wow fadeInUp"
              data-wow-delay="0.25s"
            >
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="vision-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#vision"
                    type="button"
                    role="tab"
                    aria-selected="true"
                  >
                    Our Vision
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="mission-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#mission"
                    type="button"
                    role="tab"
                    aria-selected="false"
                  >
                    Our Mission
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="values-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#values"
                    type="button"
                    role="tab"
                    aria-selected="false"
                  >
                    Our Values
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="commitment-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#commitment"
                    type="button"
                    role="tab"
                    aria-selected="false"
                  >
                    Our Commitment
                  </button>
                </li>
              </ul>
            </div>

            {/* Tabs Content */}
            <div className="vision-mission-box tab-content" id="myTabContent">
              {/* Vision Tab */}
              <div
                className="tab-pane fade show active"
                id="vision"
                role="tabpanel"
              >
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="vision-mission-content">
                      <div className="section-title">
                        <h3 className="wow fadeInUp">Our Vision</h3>
                        <h2 className="text-anime-style-3" data-cursor="-opaque">
                          Becoming India’s Most Trusted Car Rental Brand
                        </h2>
                        <p className="wow fadeInUp" data-wow-delay="0.25s">
                          Our aspiration is to become the most reliable travel companion, crafting enriching journeys that spark exploration and create cherished memories.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="vision-image">
                      <figure className="image-anime reveal">
                        <img
                          src="images/outstation-2.jpg"
                          alt="Our Vision"
                          className="img-fluid rounded shadow"
                        />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mission Tab */}
              <div className="tab-pane fade" id="mission" role="tabpanel">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="vision-mission-content">
                      <div className="section-title">
                        <h3>Our Mission</h3>
                        <h2 data-cursor="-opaque">
                          Redefining Travel Convenience & Customer Satisfaction
                        </h2>
                        <p>
                          At <strong>Aaryan Travels</strong>, our mission is to deliver end-to-end travel services with a focus on comfort, convenience, and customer satisfaction, ensuring hassle-free journeys across India and abroad.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="vision-image">
                      <figure className="image-anime reveal">
                        <img
                          src="images/outstation-3.jpg"
                          alt="Our Mission"
                          className="img-fluid rounded shadow"
                        />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>

              {/* Values Tab */}
              <div className="tab-pane fade" id="values" role="tabpanel">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="vision-mission-content">
                      <div className="section-title">
                        <h3>Our Values</h3>
                        <h2 data-cursor="-opaque">What Drives Us Forward</h2>
                        <p>
                          At <strong>Aaryan Travels</strong>, our core values centre around putting our customers first, handling every trip with utmost care and attention. We stand for honesty, clarity, and dependability, delivering genuine services that our clients can count on. Our team is dedicated to upholding high standards, prioritising safety, comfort, and ongoing innovation. We respect every traveller, always striving to provide meaningful and unforgettable travel experiences.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="vision-image">
                      <figure className="image-anime reveal">
                        <img
                          src="images/outstation-6.jpg"
                          alt="Our Values"
                          className="img-fluid rounded shadow"
                        />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>

              {/* Commitment Tab */}
              <div className="tab-pane fade" id="commitment" role="tabpanel">
                <div className="row align-items-center">
                  <div className="col-lg-6">
                    <div className="vision-mission-content">
                      <div className="section-title">
                        <h3>Our Commitment</h3>
                        <h2 data-cursor="-opaque">
                          Delivering Comfort, Safety, and Reliability
                        </h2>
                        <p>
                          At <strong>Aaryan Travels</strong>, we are committed to delivering comfort, safety, and reliability in every journey. With professionalism and customer care at the heart of our services, we ensure every ride reflects our promise of quality and trust.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6">
                    <div className="vision-image">
                      <figure className="image-anime reveal">
                        <img
                          src="images/outstation-4.jpg"
                          alt="Our Commitment"
                          className="img-fluid rounded shadow"
                        />
                      </figure>
                    </div>
                  </div>
                </div>
              </div>
              {/* End Commitment */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VisionMissionnew;